// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"2":"6c9b561cf966809ba0c3","18":"5d089e5c0f493cb474b1","48":"bdb0bfb2bb55998c653f","232":"f09e3fbaa67e5132e559","243":"847fa6b8a8f247135d84","557":"404a7cd38c7e06afd6e7"}[chunkId] + ".js";
};